import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'

Vue.component('v-select', vSelect)

Vue.use(VueMoment, {
  moment,
})

Vue.use(VueAxios, axios)

new Vue({
  el: '#schedules_app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js